export default __webpack_public_path__ + "static/media/TorpedoClosed.4fda4564.jpg";